import type { UploadJob } from 'common/types/uploadJob';
import { createStore } from 'cross-state';

const globalState = createStore({
    uploadJobs: [] as UploadJob[],

    pushSupported: undefined as boolean | undefined,
    pushPermissionGranted: undefined as boolean | undefined,
    pushSubscription: undefined as PushSubscription | undefined,

    search: {
        open: false,
    },
});

export default globalState;
Object.assign(globalThis, { globalState });
